import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { slide as Menu } from 'react-burger-menu';

import { Link } from 'react-router-dom';
import { project } from '../../utils/project';

import './navbarsub.styles.scss';



const NavBarSub = ({pageType,articlesData,location,url}) => {

  const [menuOpenState, setMenuOpenState] = useState({menuOpen: false});
  const handleStateChange = (state) => {
    setMenuOpenState({menuOpen: state.isOpen});  
  }  

  const closeMenu = () => {
    setMenuOpenState({menuOpen: false});
  }

  return(
    <React.Fragment>
      <nav id="navsubID" className="navsubbarhome">
      <MediaQuery maxWidth={768}>          
        <ul className="navsub-menu-sub-left">
        {
          pageType === "articles" ?
            <li className="navsub-item-sub-left articleMenuWrapper">
              <div id="article-menu-outer-container">            
                <Menu 
                  left 
                  isOpen={menuOpenState.menuOpen}
                  onStateChange={(state) => handleStateChange(state)}
                  width={'280px'} 
                  pageWrapId={ "mainID" } 
                  outerContainerId={ "article-menu-outer-container" }
                  customBurgerIcon={ <img src="/assets/images/menu-makale.png" alt="Blog" /> } 
                  customCrossIcon={ <img src="/assets/images/menu-toggle-off.png" alt="Gizle" /> }
                >
                  {
                    articlesData !== null && articlesData.articles.length > 0 &&
                      articlesData.articles.map((currentArticle,index) => {
                        let selected = "";
                        if (location.pathname === "/blog/" || location.pathname === "/blog"){
                          if (index === 0){
                            selected = "selected";
                          }
                        }else{
                          selected = location.pathname.includes(currentArticle.slug) ? 'selected' : '';
                        }
                        return(
                          <Link className={`bm-item ${selected}`} to={`${url}/${currentArticle.slug}`} onClick={closeMenu}>{currentArticle.title}</Link>
                        )
                      })
                  }
                </Menu>
              </div>
            </li>
          : 
            <li className="navsub-item-sub-left">&nbsp;</li>
        }
          <li className="navsub-item-sub-left">&nbsp;</li>
        </ul>
      </MediaQuery>
      <div className="navsubbarhome-container">
          <Link to="/" className="logoContainer">
            <img className="navsubbarhome-logo" src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt={project.projectName} />
          </Link>        
        </div>

      </nav>

    </React.Fragment>
  )
};


export default NavBarSub;

